import { useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"

export const useBusinessAccountId = () => {
  const { userInfo, isAdmin } = useSelector((state) => state.auth)
  const [searchParams] = useSearchParams()
  const business_account_id = isAdmin
    ? searchParams.get("business_account_id")
    : userInfo?.current_business_account_id

  return business_account_id
}
